import { useRef, useState, useEffect } from 'react'
import styled from 'styled-components'
import { MdSearch, MdClose } from 'react-icons/md'
import Message from 'common/message'
import { FaGithub } from 'react-icons/fa'
import { useSearchRepo, useFirstRepos } from 'querys/github'
import { SecondaryButton, TransparentButton as TB } from 'common/button'
import { useUpdateProjectStatus, handleUpdate } from 'mutations/projects'
import { LinearProgress } from '@material-ui/core'
import RepositoriesList from 'student/projects/repository-update/repositories-list'
import RepositoryStatus from 'student/projects/repository-update/repository-status'
import NoRepos from 'student/projects/repository-update/no-repos'
import useSession from 'querys/session'
import { Typography } from 'common/typography'

const PlanProjectRevisionStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 3rem);
  .no-repos {
    height: 100%;
  }
  /* .aside-title {
    display: flex;
    justify-content: space-between;
    margin-block-end: 1rem;
  } */
  .repository-status {
    max-block-size: initial;
    color: white;
    background: transparent;
    padding: 0;
    overflow: initial;
    .change-repository {
      color: var(--turquoise);
      text-decoration: underline;
    }
    .field-tooltip-title {
      font: var(--headline6);
    }
    .field-tooltip {
      display: flex;
      color: #FFDD66;
    }
    .homepage-link a {
      color: var(--turquoise);
    }
    .stack-tag {
      background: var(--white);
      color: var(--neutral110);
    }
  }
  .form {
    position: relative;
    border-radius: 8px;
    background: transparent;
    max-width: auto;
    flex: 1;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    &-restart {
      width: 24px;
      height: 24px;
      background: red;
    }
    .label-container {
      max-height: 500px!important;
    }
    &-fieldset {
      flex: 1;
      border: none;
      border: none;
      padding-inline: 0px;
      padding-block: 0px;
      margin-inline: 0px;
      width: 100%;
    }
    &-btns {
      margin-top: 60px;
      display: grid;
      grid-template-columns: 1fr;
      column-gap: 16px;
      row-gap: 16px;
    }
    &-legend {
      font-weight: bold;
      font-size: 24px;
      line-height: 32px;
      color: var(--neutralText);
      opacity: .8;
      margin-bottom: 32px;
    }
    &-label {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 16px;
      span {
        display: block;
        margin-left: 8px;
        opacity: .8;
        &:first-of-type {
          color: var(--neutralText);
        }
      }
      .bold-span {
        font-weight: 700;
      }
    }
    &-info {
      position: relative;
    }
    &-input {
      display: block;
      height: 48px;
      box-sizing: border-box;
      padding: 12px 16px;
      border-radius: 4px;
      border: 1px solid var(--neutral60);
      display: flex;
      align-items: center;
      background: var(--white);
      margin-bottom: 4px;
      max-width: calc(100vw - 64px);
      input {
        width: 100%;
        margin-left: 10px;
        background: var(--white);
        color: var(--neutral80);
        font-family: var(--primaryFont);
        outline: none;
        border: none;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        padding: 0;
        line-height: 24px;
        &::placeholder {
          color: var(--neutral60);
        }
      }
    }
    &-state {
      align-self: flex-end;
      color: var(--secondary);
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        cursor: pointer;
      }
    }
    .close {
      float: right;
    }
    .form-input {
      margin: 0;
      max-width: initial;
    }
  }
  @media(min-width: 768px) {
    .form {
      &-btns {
        position: absolute;
        right: 24px;
        bottom: 24px;
        grid-template-columns: repeat(2, min-content);
        justify-content: end;
      }
    }
  }
`

function PlanProjectRevision({
  setOpen, project, refetch, requirements,
}) {
  const { profile: { username } } = useSession()
  const ref = useRef()
  const {
    mutate, error, success, setError, errorMessage, isLoading: isSendingToRevision,
  } = useUpdateProjectStatus()
  const { data: initalRepos, isError } = useFirstRepos()
  const {
    value, setValue, setEnabled, data, isLoading: searchLoading,
  } = useSearchRepo()
  const [projectFiltered, setProjectsFiltered] = useState(null)
  const [selected, setSelected] = useState({})
  const [disabled, setDisabled] = useState(true)
  useEffect(() => {
    if (value === '') {
      setSelected({})
    }
  }, [value])
  useEffect(() => {
    if (error) {
      setDisabled(true)
    }
    if (success) {
      setOpen(false)
      refetch()
    }
  }, [error, success])
  const handleSumit = (e) => {
    e.preventDefault()
    if (disabled) return
    const {
      homepage, topics, name, description,
    } = selected
    handleUpdate({
      project,
      repository_slug: name,
      project_url: homepage,
      stack: topics,
      mutation: mutate,
      description,
      level: document.querySelector('input[name="requirements_level"]:checked')?.value,
    })
  }
  const handleChange = (e) => {
    setValue(e.target.value)
    const filter = initalRepos?.filter(({ name }) => name.toLowerCase().includes(e.target.value))

    if (filter?.length > 0) {
      setProjectsFiltered(filter)
      setEnabled(false)
    } else {
      setProjectsFiltered([])
      setEnabled(true)
    }
  }

  const closeRepoList = () => {
    setDisabled(true)
    setSelected({})
    setValue('')
    setError(false)
  }
  const handleClose = (e) => {
    if (e) {
      e.preventDefault()
    }
    setEnabled(true)
    setSelected({})
    setDisabled(true)
    setValue('')
    setOpen(false)
  }
  return (
    <PlanProjectRevisionStyled>
      <div className="aside-title">
        <Typography font="headline6">
          Vincular repositorio
        </Typography>
        <TB onClick={() => handleClose(false)}>
          <MdClose size={24} />
        </TB>
      </div>
      <form id="repo-form" className="form" role="search" aria-labelledby="Seleccionar repositorio" ref={ref}>
        <fieldset className="form-fieldset">
          <label className="form-label" htmlFor="search_repo">
            <FaGithub size="20px" />
            <span>Github:</span>
            <span className="bold-span">
              {' '}
              {username}
            </span>
            <span className="bold-span">
              {' '}
              {selected?.name ? `/ ${selected.name}` : '' }
            </span>
          </label>
          {isSendingToRevision && (
            <div className="loading-bar">
              <LinearProgress />
            </div>
          )}
          {!selected?.name && (
          <div className="form-input">
            <MdSearch size="27" color="var(--neutral80)" />
            <input
              id="search_repo"
              type="text"
              value={value}
              onChange={(e) => handleChange(e)}
              placeholder="Buscar repositorio"
              autoComplete="off"
            />
            {value !== '' && <TB id="restart-form" onClick={() => closeRepoList()} />}
          </div>
          )}
          {isError && (
            <Message error>
                  Ha ocurrido un error al cargar tus repositorios, comunicalo con nosotros a
              {' '}
              <a href="mailto:me@leonidasesteban.com">me@leonidasesteban.com</a>
              {' '}
                  o a travez del medio de tu preferencia.
            </Message>
          )}
          {value === '' && !selected?.name && <NoRepos />}
          {value !== '' && !selected?.name && (
            <RepositoriesList
              projectFiltered={projectFiltered}
              repos={data?.items}
              setSelected={setSelected}
              searchLoading={searchLoading}
            />
          )}
          {selected?.name ? (
            <>
              <RepositoryStatus
                selected={selected}
                setDisabled={setDisabled}
                setSelected={setSelected}
                closeRepo={closeRepoList}
                requirements={requirements}
              />
            </>
          ) : null}
          {error && (
          <Message margin="8px 0px 0px 16px" error>
            {errorMessage || (
                  <>
                    Ha ocurrido un error interno, por favor reportalo en discord.
                  </>
            )}
          </Message>
          )}
          {/* {isLoading && ( */}
          {/* )} */}
        </fieldset>
        <SecondaryButton height="40" disabled={disabled} onClick={(e) => handleSumit(e)} fullWidth>
            Mandar a revisión
        </SecondaryButton>
      </form>
    </PlanProjectRevisionStyled>
  )
}

export default PlanProjectRevision
